import React, { useEffect, useState } from "react";
import './style.css';
import { Layout, Switch, Select, Menu, Dropdown, Breadcrumb, Table, Button, Space, Input, Row, Col, Divider, Spin } from 'antd';
import { PlusOutlined, MoreOutlined, SearchOutlined, SyncOutlined, EditOutlined, } from '@ant-design/icons';
import { Link, useHistory, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { BiSortUp } from 'react-icons/bi';
import { FaFilter } from 'react-icons/fa';
import Container from '../Layout/Container';
import { getAllUsers, manageAlluserSelector, clearState, userStatusChange } from './manageuserSlice';
import Can from '../../config/Can';
import ability from '../../config/ability';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { Option } = Select;
const ntop = "none";
const nbottom = "bottomCenter";
export default function ManageUser() {

  const dispatch = useDispatch();
  let history = useHistory()

  const [isLoading, setLoading] = React.useState(false);

  const { isFetching, isSuccess, isError, errorMessage, viewAlluser, userCount } = useSelector(
    manageAlluserSelector
  );

  const [manageUserData, setDataSource] = useState([]);
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('All');


  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getAllUsers(1));
  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);

      toast.error(errorMessage);

    }
    if (isSuccess) {
      setLoading(false);
      setDataSource(viewAlluser);
    }
  }, [isError, isSuccess, setLoading, viewAlluser, setDataSource]);

  const handleMenuClick = (e, row) => {
    //console.log("click", row);
    if (e.key == 1) {
      // history.push('/edit-department',{department_name:row.departmentName});
      history.push({
        pathname: '/edit-user',
        // search: '?query=abc',
        state: { username: row.username }
      });
    }
  }

  const goToProfile = (row) => {
    history.push({
      pathname: '/view-user',
      // search: '?query=abc',
      state: { username: row.username }
    });
  }

  const menu = (row) => (
    <Menu onClick={(e) => handleMenuClick(e, row)}>
      <Menu.Item key="1">
        <EditOutlined /> &nbsp; Edit
      </Menu.Item>
    </Menu>
  );

  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    // if (index === 4) {
    //   obj.props.colSpan = 0;
    // }
    return obj;
  };

  const columns = [
    {
      title: 'User Name',
      dataIndex: 'username',
      render: (text, row, index) => {
        return {
          children: <a onClick={() => goToProfile(row)}>{text}</a>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      // defaultSortOrder: 'ascend',
      // sorter: {
      //   compare: (a, b) => a.name - b.name,
      //   multiple: 3,
      // },
      onFilter: (value, record) => record.address.indexOf(value) === 0,
      sorter: (a, b) => a.name.length - b.name.length,
      sortDirections: ['descend', 'ascend'],
      showSorterTooltip: false,
      render: renderContent,
    },
    {
      title: 'Appointments',
      dataIndex: 'rolename',
      render: renderContent,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      render: renderContent,
    },
    {
      title: 'Department',
      dataIndex: 'departmenttype',
      render: renderContent,
    },
    {
      title: 'Department Type',
      dataIndex: 'departmenttypename',
      render: renderContent,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      className: ability.can('manageUsersTab', 'enable/disableUser') ? 'show' : 'hide',
      render: (text, row, index) => {
        return {
          children: <Can I="manageUsersTab" a="enable/disableUser">{row.status == "true" ? <Switch defaultChecked onChange={(v) => onChange(v, row)} /> : <Switch onChange={(v) => onChange(v, row)} />
          }</Can>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    // {
    //   title: 'Status',
    //   dataIndex: 'status',
    //   render: (text, row, index) => {
    //     return {
    //     children:  <Switch
    //       checked={text==="true"?true:false}
    //       onChange={(e)=>onChange(e,row)}
    //     />
    //     };
    //   },
    // },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      fixed: "left",
      width: 100,
      className: ability.can('manageUsersTab', 'editUser') ? 'show' : 'hide',
      render: (text, row, index) => (
        <Can I="manageUsersTab" a="editUser">
          <Dropdown
            overlay={() => menu(row)}
            trigger={["click"]}
            placement="bottomRight"
            arrow
          >
            <a
              style={{ color: "#c5c7cd", fontSize: 25 }}
              onClick={(e) => e.preventDefault()}
            >
              <MoreOutlined />
            </a>
          </Dropdown>
        </Can>
      ),
    },
    // {
    //   title: '',
    //   dataIndex: '',
    //   key: 'x',
    //   render: () => <a style={{color:'#c5c7cd',fontSize:25}}><MoreOutlined /></a>,
    // },
  ];


  function handleChange(value) {
    // console.log(`selected ${value}`);
  }



  const onChange = (checked, sendData) => {
    // console.log(`switch to ${checked} ==> ${sendData.name} `);
    const data = { "username": sendData.username };
    //console.log(data)

    dispatch(userStatusChange(data));
    // checked===true?dispatch(userStatusChange(data)):dispatch(userStatusChange(data))
    //dispatch(getAllUsers(1));
  };






  let dataSource = isLoading
    ? []
    : manageUserData ? manageUserData.map(row => ({
      username: row.username,
      name: row.name,
      rolename: row.roleName,
      department: row.department,
      type: row.type,
      departmenttype: row.departmentType,
      departmenttypename: row.departmentTypeName,
      // status: row && row.active && row.active[0] ? row && row.active && row.active[0]: row && row.active && row.active[0]  })):[];
      status: row && row.active && row.active[0]
    })) : [];

  //dataSource = dataSource?dataSource.slice().sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())):[];

  // console.log(dataSource)

  const handleChangeUser = (v) => {

    if (search) {
      let filterType = 'all=true';
      if (typeFilter == 'All') {
        filterType = '&all=true';
      }
      else {
        filterType = '&other=' + typeFilter;
      }
      let s = '&search=' + search;
      let d = '&departmentName=Chief of Air Staff';
      let q = v.current + filterType + s + d;
      dispatch(getAllUsers(q));
    }
    else {
      dispatch(getAllUsers(v.current));
    }


  }

  const handleChangeFilter = (v) => {
    setTypeFilter(v);
    if (search) {
      let filterType = 'all=true';
      if (v == 'All') {
        filterType = '&all=true';
      }
      else {
        filterType = '&other=' + v;
      }
      let s = '&search=' + search;
      let d = '&departmentName=Chief of Air Staff';
      let q = 1 + filterType + s + d;
      // console.log('fchange ' + v)
      // console.log(q)
      dispatch(getAllUsers(q));

    } else {
      if (v == 'All') {
        let q = 1;
        dispatch(getAllUsers(q));
      }
      else {
        let d = '&departmentName=Chief of Air Staff';
        let q = 1 + '&other=' + v + d;
        dispatch(getAllUsers(q));
      }
    }
    // console.log(v)
  }
  return (
    <>
      <Container>
        {/* <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>List</Breadcrumb.Item>
        <Breadcrumb.Item>App</Breadcrumb.Item>
      </Breadcrumb> */}
        {/* <div className="site-layout-content" style={{marginTop:35,border: '1px solid #dfe0eb'}}> */}
        {/* <div className="site-layout-content" style={{marginTop:35,marginBottom:35,border:"1px solid #dfe0eb"}}> */}
        <div className="site-layout-content" style={{ marginTop: 5 }}>
          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isFetching} />
            <h2 style={{ backgroundColor: "#ffffff", paddingLeft: 16, paddingTop: 20, borderTop: '1px solid #dfe0eb', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', marginBottom: 0 }}>Users ({userCount ? userCount : 0})</h2>
            <Space style={{ backgroundColor: "#ffffff", padding: 16, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb' }} size="large">
              <Row style={{ width: '100%' }}>
                <Col span="19">
                  {/* <Search placeholder="Search process"  size="large"  /> */}
                  <Space style={{ width: '100%' }}>
                    <Input placeholder="Search by Appointment" size="large" suffix={<SearchOutlined />}
                      onChange={e => {
                        const currValue = e.target.value;
                        setSearch(currValue);
                        // const filteredData = viewAlluser.filter(entry =>
                        //   entry.name.includes(currValue)
                        // );
                        //setDataSource(filteredData);
                        let filterType = 'all=true';
                        if (typeFilter == 'All') {
                          filterType = '&all=true';
                        }
                        else {
                          filterType = '&other=' + typeFilter;
                        }
                        let s = '&search=' + currValue;
                        let d = '&departmentName=Chief of Air Staff';
                        let q = 1 + filterType + s + d;
                        // console.log(q)
                        if (currValue) {
                          dispatch(getAllUsers(q));
                        }
                        else {
                          dispatch(getAllUsers(1));
                        }

                      }} />

                    <Select
                      id={'filtersearch'}
                      // labelInValue={true}
                      optionLabelProp="label"
                      placeholder={
                        <React.Fragment>
                          Filter By
                        </React.Fragment>
                      }
                      defaultValue={typeFilter}
                      style={{ width: 300 }}
                      onChange={handleChangeFilter}>
                      <Option label='Filter By Type (All)' value="All">All</Option>
                      <Option label='Filter By Type (Clerk)' value="Clerk">Clerk</Option>
                      <Option label="Filter By Type (DD's & AD's)" value="DD's %26 AD's" >DD's & AD's</Option>
                      <Option label='Filter By Type (CHD)' value="CHD">CHD</Option>
                    </Select>
                  </Space>


                </Col>
                {/* <Col span="3" style={{color:"#c5c7cd",padding:7,paddingLeft:25,paddingRight:1}}> <BiSortUp style={{fontSize:16}}/> <span style={{color:'#61667f'}}>Sort</span></Col>
    <Col span="3" style={{color:"#c5c7cd",padding:7,paddingLeft:0,paddingRight:0,marginLeft:-25}}><FaFilter/> <span style={{color:'#61667f'}}>Filter</span></Col> */}
                {/* <Col span="4" style={{textAlign:'right'}}> */}
                <Col span="5" >
                  <Space>
                    <Link to="/view-all-user"><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 19 }} type="link" ghost>View All User</Button></Link>
                    <Can I="manageUsersTab" a="createUser"><Link to="/add-user"><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" icon={<PlusOutlined />}>Add User</Button></Link></Can>
                  </Space>
                </Col>
              </Row>


            </Space>
            <Table columns={columns}
              onChange={handleChangeUser}
              // pagination={{ position: [ntop, nbottom],size:'small' }}
              pagination={{ position: [ntop, nbottom], size: 'small', total: userCount, hideOnSinglePage: true }}
              dataSource={dataSource} bordered />
          </div>

        </div>
      </Container>
    </>
  );
}
